module.exports = __webpack_public_path__ + "static/media/back-arrow.f24a2982.svg";